import { FormStore, useStoreState } from '@ariakit/react'
import { FC } from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { useEmbroidery } from '../../../../../../containers/EmbroideryContainer/EmbroideryProvider'
import { IconFormValues } from '../../../../../../containers/EmbroideryContainer/types'
import {
  EmbroideryIcon,
  EmbroideryIconGroup,
  useEmbroideryDesignsQuery,
} from '../../../../../../containers/EmbroideryContainer/useEmbroideryDesigns'
import { EmbroideryIconGroupSection } from '../../../../Modal/primitives/EmbroideryIconGroupSection/EmbroideryIconGroupSection'
import {
  EmbroideryOptionWrapper,
  ErrorMessage,
} from '../../../../Modal/primitives/shared-form-styles'

import { IconName, IconSelectorLabel, LabelWrapper } from './styles'

interface Props {
  labelId: string
  form: FormStore<IconFormValues>
}

export const IconSelectorForm: FC<Props> = ({ form, labelId }) => {
  const { data: embrioderyDesigns } = useEmbroideryDesignsQuery()
  const { productColorHex } = useEmbroidery()

  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()

  const iconImage = useStoreState(form, s => s.values.iconImage)
  const errorMessage = useStoreState(form, () =>
    form.getFieldTouched('iconImage') ? form.getError('iconImage') : undefined
  )

  const handleSelectIcon = (icon: EmbroideryIcon, group: EmbroideryIconGroup) => {
    if (iconImage && iconImage === icon) {
      form.setValue('iconImage', undefined)
    } else {
      form.setValue('iconImage', { ...icon, group })
    }
  }

  const embroideryIconGroupsView = (embrioderyDesigns?.embroideryOptions.iconGroups ?? []).map(
    group => {
      return (
        <EmbroideryIconGroupSection
          key={`icon-group-${group.id}`}
          group={group}
          selectedIcon={iconImage}
          onSelectIcon={newSelection => handleSelectIcon(newSelection, group)}
          productColorHex={productColorHex}
        />
      )
    }
  )

  const selectedImage = iconImage?.image

  return (
    <EmbroideryOptionWrapper>
      <LabelWrapper>
        <IconSelectorLabel id={labelId}>{fixtures.iconOption.iconSelectorLabel}</IconSelectorLabel>
        {selectedImage && selectedImage.label && <IconName>{selectedImage.label}</IconName>}
      </LabelWrapper>

      {embroideryIconGroupsView}

      {errorMessage && (
        <ErrorMessage inset role='alert'>
          {errorMessage}
        </ErrorMessage>
      )}
    </EmbroideryOptionWrapper>
  )
}
